import { useEffect, useState } from 'react';
import URL_CONSTANT from '../../constants/url.constants.js';

export default function useHeaderState(userDep) {
  const [isOn, toggleIsOn] = useState(false);
  const [pathData, setPathData] = useState({ url: '/' });

  useEffect(() => {
    const pathName = window.location.pathname.substring(1);
    setPathData(pathName ? URL_CONSTANT[pathName] : URL_CONSTANT.home);

    const handleResize = () => { if (window.innerWidth > 650) toggleIsOn(false); };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [userDep]);

  return { isOn, toggleIsOn, pathData };
}
